export const translationPT = {
  error: {
    401: {
      title: 'Não autorizado',
      description: 'Você não tem autorização para visualizar esta página.',
      button: 'Voltar à página inicial'
    },
    'slug-must-be-unique': 'O slug deve ser único', 
  },
  components: {
    menu: {
      logout: 'Sair',
    },
    footer: {
      policyprivacy: 'Politica de privacidad',
      aboutus: 'Nosotros',
      termsofservice: 'Terminos y condiciones',
    },
    table: {
      show: 'Mostrar',
      notresults: 'Sem resultados',
    },
    navbar: {
      home: 'Início',
      users: 'Utilizadores',
      product_enrollments: 'Inscripciones a producto',
      commison_enrollments: 'Inscripciones a turmas',
      products: 'Produtos',
      products_career: 'Carreira',
      products_course: 'Curso',
      products_on_demand: 'On Demand',
      products_on_demand_b2b: 'On Demand B2B',
      productList: 'Produtos',
      subjects: 'Materiais',
      modules: 'Módulos',
      courses: 'Turmas',
      myCourses: 'Minhas turmas',
      students: 'Estudantes',
      course: 'Cursos',
      courseConfig: 'Configuração do curso',
      paths: 'Caminho',
      subjectVersions: 'versões de matéria',
    },
    home: {
      welcome_title: 'Bem-vindos a ',
      welcome_product_text: 'SMS',
      welcome_subtitle: 'Student Management System',
    },
    'state-icon': {
      create: 'C',
      open: 'A',
      close: 'C',
      opened: 'A',
      finaliced: 'F',
      closed: 'C',
      'create-tooltip': 'Criado em',
      'open-tooltip': 'Aberto',
      'close-tooltip': 'Fechado',
      'opened-tooltip': 'Aberto',
      'finaliced-tooltip': 'Fim',
      'closed-tooltip': 'Fechar',
    },
  },
  attendance: {
    title: 'Frequência',
    'sub-title': 'Comissão',
    attendance: 'Frequência',
    registry: 'Registo de presenças',
    'students-not-found': 'A lista de estudantes não foi encontrada',
    'state-present': 'Presente',
    'state-late': 'Tarde',
    'state-no-registry': 'Estado inicial',
    justify: 'desculpados',
    'state-justify': 'Justificado',
    'get-attendance': 'Assistir',
    'state-absent': 'Ausente',
  },
  resources: {
    progressDisplay: {
      title: 'Exibição de progresso',
      select: 'Selecione uma exibição de progresso',
      percent: 'Percentagem',
      stage: 'Estágio',
      percent_with_final_stage: 'Porcentagem com situação final',
    },
    users: {
      viewProfile: 'Ver perfil',
    },
    staff: {
      requires: 'Necessário:',
    },
    exceptionsGroups: {
      select: 'Seleccione Feriados',
    },
    lessons: {
      create: 'Criar Classe',
      new: 'Adicionar classe',
      quantity: 'Número de classes',
    },
    modules: {
      create: 'Criar Módulo',
      created: 'Módulo Criado',
      edit: 'Editar Módulo',
      new: 'Novo Módulo',
      'async-lesson-add': '+ Classe Assíncrona',
      'sync-lesson-add': '+ Classe Síncrona',
      'async-lessons': 'Classes Assíncronas',
      'sync-lesson': 'Classe Síncrona',
      'sync-lesson-placeholder': 'Inserir Nome da Classe',
      'async-lesson-placeholder': 'Inserir Nome da Classe Assíncrona',
      plan: 'Planejamento do módulo',
      'description-placeholder': 'Descreva o módulo',
      'warning-courses-linked':
        'Esta versão tem turmas ativas vinculadas. Qualquer alteração feita nele não afeta as turmas ativas..',
    },
    periodicities: {
      onceaweek: 'Uma vez por semana',
      everytweeks1: 'A cada 2 semanas a partir da primeira semana',
      everytweeks2: 'A cada 2 semanas a partir da segunda semana',
      select: 'Selecione a frequência',
    },
    products: {
      errordata: 'Falha ao obter dados. Tente novamente.',
      cluster: 'Cluster',
      create: 'Criar Produto',
      edit: 'Editar Produto',
      created: 'Produto criado',
      updated: 'Produto atualizado',
      updatederror: 'Ocorreu um erro ao atualizar o produto',
      error: 'Ocorreu um erro ao criar o produto',
      code: 'Código do Produto',
      select: 'Selecione produto',
      'select-cluster': 'Selecione Cluster',
      'select-duration': 'Selecione Duração',
      'select-course': 'Selecione comissão',
      search: 'Produto de pesquisa',
      'list-title': 'Produtos',
      'career-list-title': 'Produtos de Carreira',
      'course-list-title': 'Produtos de Curso',
      'on-demand-list-title': 'Produtos On Demand',
      'on-demand-b2b-list-title': 'Produtos On Demand B2B',
      duration: 'Duração',
      courses: 'Turmas',
      course: 'Turma',
      paths: {
        label: "Planos de estudos",
        placeholder: "Selecione o planos de estudos",
      },
      path: 'Plano de estudos',
      'path-placeholder': 'Selecione o plano de estudos',
      'slot-from': 'Faixa horária de',
      'slot-to': 'Faixa horária até',
      'admission-type': 'Tipo de admissão',
      'admission-type-placeholder': 'selecionar',
      'admition-process-async': 'Processo de admissão assíncrono',
      'admition-process-404': 'Processo de admissão (404)',
      'admition-process-placeholder': 'selecionar',
      'course-onboarding': 'Curso de embarque no Playground',
      'course-onboarding-placeholder': 'selecionar',
      'modal-enrollment': 'Execute o registo',
      'enrollment-successful': 'Inscrição bem sucedida',
      'enrollment-timeout': 'Registro em andamento, verifique novamente em alguns minutos',
      'enrollment-fail-title': 'O registro não foi concluído',
      'enrollment-simulation-fail-default': 'Tente novamente mais tarde',
      'enrollment-simulation-fail-nousers': 'Não há usuários não registrados para este produto',
      'simulation-successful-title': 'Simulação bem-sucedida',
      'simulation-successful-content': 'O arquivo foi baixado para o seu computador',
      'simulation-fail-title': ' A simulação não foi concluída',
      'simulation-button': 'Simular inscrição (.csv)',
      'enrollment-button': 'Executar inscrição',
      'enrollment-modal-question':
        'Tem certeza de que deseja realizar a inscrição para o produto <strong>{{productCode}}</strong>? Esta ação não pode ser revertida.',
      language: 'Lenguage',
      'language-placeholder': 'Selecione Lenguaje',
      enrollments: 'Inscrições',
      enrollments_title: 'Inscrições de alunos do produto',
      enroll_users: 'Inscrever aluno no Produto',
      user_list: 'Selecione o(s) usuário(s) para registrar o produto',
      confirm_enroll: 'Inscrever',
      enrollment_error: 'Ocorreu um erro ao cadastrar o usuário, verifique se o usuário já existe ou tente novamente mais tarde',
      enrollment_requiered: 'Você deve selecionar pelo menos um aluno',
      enrollment_success: 'Alunos matriculados com sucesso',
      enrollment_student_data: 'Dados do aluno',
      enrollment_product_data: 'Datas do produto',
      enrollment_not_found: 'Não consegue encontrar o usuário?',
      enrollment_create_option: '+ Criar novo usuário',
      'course-edit': 'Editar Comissão',
      'course-detail': 'Detalhe de Comissão',
    },
    sessions: {
      'list-title': 'Lista de sessões',
      'show-async-class': 'Ver aulas assíncronas',
      open: 'Aula aberta',
      'open-sucess': 'Aula aberta corretamente',
      'open-failed': 'Ocorreu um erro ao abrir a aula',
      type: 'Tipo',
      state: 'Status',
      programmed: 'Agendado para',
      sync: 'Síncrono',
      async: 'Assíncrono',
      dictated: 'Emitido',
      released: 'Lançado',
      pending: 'Pendente',
      'not-released': 'A ser lançado',
      'scheduled-range': '{{- start}} a {{- end}}',
    },
    students: {
      'list-title': 'Alunos',
      'import-title': 'Importar do arquivo',
      'finder-place-Holder': 'Procurar um novo aluno',
      'profile-title': 'Dados pessoais',
      name: 'Nome',
      'last-name': 'Sobrenome',
      birthdate: 'Data de nascimento',
      'job-title': 'Cargo',
      'document-type': 'Tipo de documento',
      'document-number': 'Número do documento',
      'fiscal-id-type': 'Tipo de identificação fiscal',
      'fiscal-id-number': 'Número de identificação fiscal',
      'fiscal-title': 'Dados fiscais',
      'contact-title': 'Dados de contato',
      email: 'Email',
      'phone-code': 'Código. país',
      phone: 'Número de telefone',
      country: 'País de residência',
      address: 'Endereço',
      studyng: 'Estudando',
      abandoned: 'Abandonado',
      approved: 'Aprovado',
      disapproved: 'Reprovado',
      recuperatory: 'Recuperação',
      undefined: 'Sem Estado',
      assistance: 'de presença',
      product: {
        title: 'Produto',
        select: 'Selecionar produto',
        code: 'Código',
        date: 'Cadastro feito no dia',
        status_on_product: 'Status do aluno no produto'
      },
      import: {
        select_title: "Seleção de arquivo",
        validate_title: "Data de validade",
        import_data_title: "Importação de dados",
        input_csv_label: "Baixar arquivo de modelo",
        select_file: "Selecione um arquivo CSV",
        warning: {
          title: '¡Atenção!',
          description: 'Identificamos alguns dados que podem exigir validação adicional de sua parte antes da importação. É importante que você revise esses detalhes cuidadosamente para garantir que as informações permaneçam precisas e completas. Pode haver discrepâncias ou dados faltantes que possam afetar a integridade da importação. Reserve um momento para verificar e corrigir esses dados antes de prosseguir com a importação.',
          student: 'Estudante',
          track: 'Track',
          lastCourse: 'Comissão atual',
          newCourse: 'Nova comissão',
          product: 'Produto',
          existanceMessage: 'O usuário não existe',
          recurringMessage: 'O aluno é recorrente',
          warningCell: {
            already_enrolled_to_subject: "O usuário já está inscrito na matéria",
            already_in_file_user_subject: "Já existe outra inscrição deste usuário nesta matéria no mesmo csv",
            comm_enr_already_exists: "O curso já existe",
            course_product_time_slot_mismatch: "Os horários do curso do produto não coincidem",
            course_enrollments_already_exists: "O usuário já está inscrito no curso",
            course_enr_not_active: "O curso não está ativo e será reativado",
            course_not_found: "O curso não existe",
            direct_enrollment_to_base_track: "O track é base e não possui lógica de matrícula automática. Recomenda-se matricular apenas no produto",
            existing_enrollment: "O usuário está repetindo o curso",
            more_than_one_prod_in_active_state: "Foram encontrados mais de um produto em estado ativo",
            product_not_found: "O produto não existe",
            prod_enr_not_found: "O curso do produto não existe",
            product_enr_not_active: "A matrícula do usuário no produto não está ativa e será reativada, juntamente com todos os seus tracks e cursos",
            track_not_found: "O track não existe",
            track_not_in_product: "O track não faz parte do produto",
            track_enr_not_active: "O track não está ativo e será reativado, juntamente com todos os seus cursos",
            user_not_found: "O usuário não existe",
            track_enrollments_already_exists: "O usuário já está inscrito na trilha",
            product_enrollments_already_exists: "O usuário já está inscrito no produto",
            user_not_active: "O usuário não está ativo",
            only_students_can_enroll_to_product: "Apenas usuários com o papel de aluno podem se inscrever em produtos",
            host_will_enroll_on_track_courses: "Você vai matricular um host em uma trilha",
            incorrect_role_input: "Papel não permitido",
            incorrect_enrollment_destination: "Relação inexistente entre o curso, trilha e produto especificado",
          },
          enrollmentCell: {
            existing_enrollment: "Mudança de comissão",
            enrollment_associate: "Associação",
            enrollment: "Cadastro",
          },
        },
        complete: {
          title: '¡Tudo pronto!',
          description: 'Seus dados foram enviados para importação. Nosso sistema está trabalhando nisso e se encarregará de processar a importação com eficiência. Observe que como a importação é feita de forma assíncrona para garantir eficiência, pode demorar um pouco até você ver os resultados.',
          import_other: 'Importar outro arquivo',
          dashboard: 'Ir para o relatório',
        },
        success_validation: {
          title: '¡Todo se ve bien!',
          description: '<paragraph>A validação dos dados dos usuários foi concluída com sucesso. Todos os dados foram revisados e confirmados sem nenhum problema. Agora está listado para levar a cabo a importação.</paragraph>',
          cancel: 'Cancelar',
          import_now: 'Importar agora',
          stats: {
            users: 'Usuários',
            enrollments: 'Inscrições',
            warnings: 'Avisos',
            errors: 'Erros'
          }
        },
        api_error: {
          title: 'Ops, estamos passando por momentos difíceis...',
          description: 'Infelizmente, tivemos problemas ao tentar carregar os dados. Por favor, tente novamente. Se o problema persistir, entre em contato com nossa equipe de suporte.</paragraph>',
          import: 'Importar outro arquivo'
        },
        error_validation: {
          title: 'Oops, algo não está de todo bem com seu arquivo...',
          description: 'Lamentavelmente, não podemos processar o arquivo que você tentou carregar. Parece haver um problema com a extensão do arquivo ou os dados não cumprem os requisitos necessários para a importação de ex-alunos.<paragraph>Certifique-se de que está carregando um arquivo com a extensão ".csv" e que os dados estão organizados em colunas sozinho por comas. Além disso, verifique se as colunas do arquivo coincidem com os campos exigidos para a importação. Si tienes alguna duda sobre el formato correto, por favor revise el archivo template o ponte en contact con nuestro equipo de suporte to obtener assistencia.</paragraph>',
          import: 'Importar outro arquivo',
          download: 'modelo de arquivo de descarga'
        },
        progress_validation: {
          title: 'validando dados',
          progress: '<span>{{quantity}}</span> de <span>{{total}}</span> registros'
        },
        progress_import: {
          title: 'importando dados'
        }
      }
    },
    shifts: {
      morning: 'Turno da manhã',
      evening: 'Turno da tarde',
      night: 'Turno da noite',
      select: 'Selecionar turno',
    },
    allowed_students: {
      any: 'Aberto',
      scholarships: 'Fechada',
      select: 'Selecione o tipo',
    },
    stages: {
      modal_change_title: 'Mudar de fase em produto',
      modal_change_title_track: 'Mudar de fase em track',
      button_change_stage: 'Mudar de fase',
      modal_confirmation_title: 'Confirmar mudança de fase em produto',
      modal_confirmation_question: 'Tem certeza de que deseja mudar de fase?',
      modal_confirmation_title_commission: 'Confirmar mudança de status de comissão',
      modal_confirmation_question_commission: 'Tem certeza de que deseja mudar de status?',
      create: 'Criar Estágio',

      admission: 'Admissão',
      studying: 'Cursando',
      on_waiting_list: 'Na lista de espera',
      in_stand_by: 'Curso em espera',
      graduate: 'Formado',
      abandoned: 'Retirado',
      enrolled: 'Inscrito',
      recuperatory: 'Recuperação',
      disapproved: 'Reprovado',
      approved: 'Aprovado',
      admitted: 'Admitido',
      in_stand_by_admitted: 'Admitido em stand by',
      abandoned_admission: 'Retirado na admissão',
      abandon_request: 'Solicitação de cancelamento',
      non_graduate: 'Não graduado',
      commission_change: 'Mudança de comissão',
      standalone_exam: 'Exame independente',
      non_attendance_studying: 'Estudo não presencial',
      deadline_expired: 'Prazo Expirado',

      'comments-about-change': 'Comentários sobre a mudança',
      select_reason: 'Seleccione motivo',
      undefined: '-',

      '1': 'Admissão',
      '2': 'Cursando',
      '3': 'Na lista de espera',
      '4': 'Curso em espera',
      '5': 'Formado',
      '6': 'Retirado',
      '7': 'Inscrito',
      '8': 'Recuperação',
      '9': 'Reprovado',
      '10': 'Aprovado',
      '11': 'Admitido',
      '12': 'Admitido em stand by',
      '13': 'Retirado na admissão',
      '14': 'solicitação de cancelamento',
      '15': 'Não graduado',
      '16': 'Mudança de comissão',
      '17': 'Estudo não presencial',
      '18': 'Exame independente',
      '19': 'Prazo Expirado',

      edges: {
        abandoned_student: 'Desistência do aluno',
        abandoned_absent: 'Desistência por não comparecimento',
        abandoned_administrative: 'Desistência por expulsão',
        abandoned_expelled: 'Desistência por mudança de curso',
        abandoned_change_course: 'Desistência por processo manual de admissão',
        abandoned_manual_admission_process: 'Desistência por rejeição',
        abandoned_rejection: 'Desistência por rejeição',
        abandoned_others: 'Desistência do aluno',
        abandoned_economic_difficulties: 'Desistência por dificuldades econômicas',
        abandoned_sickness: 'Desistência por doença',
        abandoned_admission_error: 'Desistência por erro na admissão',
        abandoned_time_management: 'Cancelar inscrição devido ao gerenciamento de tempo',
        abandoned_platform_discrepancy: 'Cancelar inscrição devido a inconsistências da plataforma',
        abandoned_difficult_content: 'Cancelar inscrição devido a conteúdo difícil',
        abandoned_easy_content: 'Cancelar inscrição devido a conteúdo fácil',
        abandoned_timeframe_changed_without_warn:
          'Cancelar inscrição devido a alteração de horário proposta',
        abandoned_assignments_time_changed_littl:
          'Desistência por pouca antecipação de mudanças de horários por bimestre',
        abandoned_scholarship_absent: 'Desistência de bolsa (Por não comparecimento)',
        abandoned_scholarship_bad_performance: 'Desistência de bolsa (Por motivos de recurso)',
        admission_manual_decision: 'Inscrição por erro na admissão',
        abandoned_charge_error: 'Baixo devido a erro de carregamento',
        abandoned_change_semester: 'Desistência por mudança de semestre',
        abandoned_personal_motives: 'Desistir por motivos pessoais',
        abandoned_work_motives: 'Licença por motivos de trabalho',
        exam_absent: 'Ausente ao exame',
        exam_failing_grade: 'Classificação insuficiente',
        abandoned_exam_retakes_limit_reached: 'Limite de tentativas de recurso',
        failing_attendance: 'Assistência insuficiente',
        abandoned_course_modality: 'Baixa por modalidade do curso',
        abandoned_expectation_mismatch: 'Baixa por expectativas não cumpridas',
        abandoned_achieved_objectives: 'Objetivos alcançados',
        abandoned_payment_default: 'Baixa por atraso no pagamento',
        abandoned_pause_requested: 'Baixa por solicitação de pausa',
        abandoned_unknown: 'Desconhecido',
      },
      'state-change-success': 'O status foi atualizado com sucesso.',
      'no-stages-available': 'Não há mais status possíveis para esta comissão.',
    },
    courses: {
      'list-title': 'Cursos',
      select: 'Selecionar curso',

      create: 'Criar Comissão',
      created: 'Comissão criada',
      'schedule-tooltip': 'Calendário',
      scheduled: 'Comissão agendada',
      'scheduled-error': 'Ocorreu um erro durante o agendamento da comissão.',
      edit: 'Comissão de edição',
      edited: 'Comissão editada',
      'detail-course': 'Detalhe',
      'career-courses': 'Turmas de Carreira',
      'product-courses': 'Turmas de Produto',
      dayselector: {
        title: 'Dias de estudo',
        button: 'Adicionar dias',
        modal: 'Adicionar dias de estudo',
      },
      detail: {
        'start-day': 'Começa no dia',
        'end-day': 'Termina em',
        'days-time': 'Dias e horários',
        calendarize: 'Horário',
        recalendarize: 'Reprogramar',
        'end-courses': 'Comissão final',
        'close-courses': 'Fechar comissão',
      },
      enrollments: {
        list_title: 'Inscripciones a turma',
      },
      modal_change_title: 'Alteração do estatuto de comissão',
      studying: 'Em curso',
      approved: 'Aprovado',
      'approved-plural': 'Aprovado',
      'disapproved-plural': 'Reprovado',
      disapproved: 'Não aprovado',
      'abandoned-plural': 'Abandonado',
      abandoned: 'Abandonado',
      versionwarning: 'Apenas as versões que estão ativas são exibidas.',
      code: 'Código Comisión',
      course_type: 'Tipo de curso',
      course_type_error: 'Ocorreu um erro ao obter a lista de tipos de cursos.',
    },
    subjects: {
      'list-title': 'Assuntos',
      create: 'Criar assunto',
      created: 'Assunto criado',
      edit: 'Editar assunto',
      edited: 'Assunto atualizado',
      'description-placeholder': 'Descreva o assunto',
      plan: 'Planejamento de aula',
      'select-classification': 'Selecionar classificação',
      'select-requirements': 'Selecionar requisitos',
      select: 'Selecionar assunto',
      sort: 'Salvar pedido',
      'sort-lessons-success': 'Ordem de aula salva com sucesso',
      'sort-modules-success': 'A ordem dos módulos foi salva corretamente',
      'sort-lessons-error': 'Ocorreu um erro ao salvar a ordem das aulas',
      'sort-modules-error': 'Ocorreu um erro ao salvar a ordem dos módulos',
      info: 'Informações do assunto',
    },
    subjectVersions: {
      'list-title': 'Versões de matéria',
      active: 'Ativo',
      inactive: 'Inativo',
      select: 'Selecione a versão',
      'disable-version-title': 'Desativar versão',
      'disable-version-error-title': 'Não foi possível desabilitar esta versão',
      'disable-version-message':
        'Isto impedirá que turmas sejam criadas com esta versão enquanto ela estiver inativa. Tem certeza que deseja desabilitar esta versão?',
      'disable-version-error-message':
        'Esta versão do assunto não pode ser desabilitada porque tem turmas relacionadas em andamento.',
      info: 'Versão informação',
      'edit-form-PG': 'Visível e editável apenas no Playground',
      edit: 'Editar versão do assunto',
      create: 'Criar versão do assunto',
      'description-placeholder': 'Descreve a versão do assunto',
      'create-success-message': 'Versão da matéria criada com sucesso.',
      'create-error-message': 'Não foi possível criar a versão da matéria.',
      'edit-success-message': 'Versão do assunto editada com sucesso.',
      'edit-error-message': 'Não foi possível editar a versão do assunto.',
      language: 'Lenguaje',
      'language-placeholder': 'Selecione Lenguaje',
      alias: 'Alias',
      'alias-hint': 'é o nome que a versão terá no Playground',
      'content': 'Conteúdo',
      'course-type': 'Tipo de curso',
      'course-type-placeholder': 'Selecione um tipo',
      'playground-course': 'Curso de Playground',
      'playground-course-placeholder': 'Selecione um curso'
    },
    timezone: {
      title: 'Fuso horário',
      select: 'Selecione o fuso horário'
    },
    paths: {
      'title-create': 'Criar plano de estudos',
      section: 'Seção',
      new: 'Adicionar seção',
      'create-success': 'Plano de estudos criado com sucesso',
      'create-error': 'Ocorreu um erro ao tentar criar o plano de estudos',
    },
    interactions: {
      'interactions-registry': 'Log de Interação',
      'create-label': 'Criar Interação',
      'new-label': 'Nova Interação',
      'write-here-label': 'Escreva os detalhes aqui',
      'error-msg-create-note': 'A nota da interação não deve exceder 4000 caracteres.',
      'success-msg-create-note': 'A interação foi criada com sucesso!',
      'empty-list-msg': 'Não há interações disponíveis no momento.',
    },
    published: {
      dialog: {
        title: 'Publicar produto',
        message: '<block>Você está prestes a publicar o produto <bold>{{code}}</bold>.</block><block>Esta ação fará com que o produto seja exibido na venda online.</block><break/><block>Tem certeza de que deseja executar esta ação?</block>',
      },
    },
    unpublished: {
      dialog: {
        title: 'Despublicar produto',
        message: '<block>Você está prestes a cancelar a publicação do produto <bold>{{code}}</bold>.</block><block>Esta ação impedirá que o produto seja exibido na venda online.</block><break/><block>Tem certeza de que deseja executar esta ação?</block>',
      },
    },
  },
  static: {
    tracks: 'Tracks',
    order: 'Ordem',
    enrollmentDate: 'Data de inscrição',
    keepEnrollment: 'Manter a inscrição do curso no Playground',
    isPlaygroundEnrollment: 'Matriculado no Playground',
    noPlaygroundEnrollment: 'Não matriculado no Playground',
    products: 'Produtos',
    durationHours: "Duração em horas",
    isFree: 'É grátis?',
    coverUrl: {
      label: 'Vídeo de capa',
      hint: 'Certifique-se de que a URL seja de um vídeo.',
    },
    modality: {
      label: "Modalidade",
      placeholder: "Escolha uma modalidade",
    },
    category: {
      label: "Categoria",
      placeholder: "Escolha uma categoria",
    },
    technology: {
      label: "Tecnologia",
      placeholder: "Escolha uma tecnologia",
    },
    level: {
      label: "Dificuldade",
      placeholder: "Escolha uma dificuldade",
    },
    theme: {
      label: 'Tema',
      placeholder: 'Escolha um tema',
    },
    icon: {
      label: 'Ícone',
      placeholder: 'Escolha um ícono',
    },
    businessUnits: {
      career: 'Carreira',
      course: 'Curso intensivo',
      in_company: 'In Company',
      inCompany: 'In Company',
      financial: 'Financial',
      on_demand: 'On Demand',
      onDemand: 'On Demand',
    },
    actual: 'atual',
    profile: 'Perfil',
    'none-selected': 'Nenhum selecionado',
    'check-in': 'Inscrição',
    subjects: 'Assuntos',
    state: 'Estado',
    actions: 'Ações',
    country: 'País',
    type: 'Tipo',
    module: 'Módulo',
    code: 'Código',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    accept: 'Aceitar',
    open: 'Abrir',
    edit: 'Editar',
    action: 'Ações',
    classification: 'Classificação',
    exceptionsGroups: 'Feriados',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: 'HH:mm',
    careers: 'Corridas',
    change_state: 'Alterar Status',
    import: 'Importar do arquivo',
    dateTimeFormat: 'DD/MM/YYYY HH:mm',
    doc: 'Documento',
    doc_type: 'Tipo de documento',
    date_time_utc: 'Dia e hora UTC',
    'days-title': 'Dias',
    days: {
      0: 'Domingo',
      1: 'Segunda-feira',
      2: 'Terça-feira',
      3: 'Quarta-feira',
      4: 'Quinta-feira',
      5: 'Sexta-feira',
      6: 'Sábado',
      L: 'L',
      M: 'M',
      X: 'X',
      J: 'J',
      V: 'V',
      S: 'S',
      D: 'D',
    },
    'days-of-study': 'Dias de curso',
    description: 'Descrição',
    'description-optional': 'Descrição (opcional)',
    'description-mandatory': 'Descrição (obrigatório)',
    duration: 'Duração',
    email: 'Email',
    date: 'Data',
    endDate: 'Data de término',
    endTime: 'Hora de término',
    end_date: 'Fim',
    filter: 'Filtro',
    id: 'Id',
    initial_date: 'Início',
    inscription: 'Inscrição',
    'inscription-plural': 'Inscrição',
    interaction: 'Interação',
    'interaction-plural': 'Interações',
    job: 'Trabalho',
    lesson: 'Aula',
    lessons: 'Aulas',
    'lessons-list': 'Lista de turmas',
    'msg-error': 'Opa! Parece que houve um erro.',
    'msg-loading': 'Um momento, por favor! Estamos processando sua solicitação.',
    'msg-required': 'Todos os campos obrigatórios devem ser preenchidos',
    'msg-success': 'Parabéns! Tudo correu bem.',
    'msg-warning': 'Cuidado! Parece que alguns dados estavam faltando.',
    name: 'Nome',
    name_of_course: 'Nome do comitê',
    periodicity: 'Frequência',
    phone: 'Telefone',
    requirements: 'Requisitos',
    save: 'Salvar',
    shift: 'Virar',
    startDate: 'Data de início',
    startTime: 'Hora de início',
    subject: 'Assunto',
    subject_course: 'Curso',
    course: 'Curso',
    openDate: 'Data de abertura',
    surname: 'Sobrenome',
    select: 'Selecionar',
    vacancy: 'Vagas',
    validators: {
      isNumber: 'O campo deve ser um número',
      required: 'O campo é obrigatório',
      urlRequired: 'Insira uma URL válida',
      min: 'Deve conter pelo menos {{num}} caracteres',
      regex: '{{message}}',
      'version-mismatch': 'A versão deve ter o formato v.MMYYYY',
      itsBiggerThan: 'O campo {{ field1 }} não pode ser maior que {{field2}}',
      email: 'O campo deve ser um email válido',
      maxCharsAndSpace: 'Deve conter no máximo 6 caracteres alfanuméricos e sem espaços',
      invalidSlug: 'O slug deve conter apenas letras minúsculas, números e hífens',
    },
    version: 'Versão',
    staff: {
      1: 'Alunos',
      2: 'Proprietário',
      3: 'Assistente',
      4: 'Treinador',
      5: 'Host',
    },
    'staff-optional': 'Equipe (opcional)',
    sessions: 'Sessões',
    create: 'Criar',
    nonrequired: 'Campo não obrigatório',
    'save-changes': 'Salvar alterações',
    'order-symbol': 'º',
    alias: 'Alias',
    aliasHint: 'É o nome que o curso terá no Playground para o aluno',
    catalogVisibility: {
      label: 'Mostrar no explorar',
      placeholder: 'Selecione uma opção',
      options: {
        true: 'Sim',
        false: 'Não',
      },
      hint: 'Se você selecionar esta opção, o curso será visível na seção explorar',
    },
    slug: 'Slug',
    slugDescription: 'Deve conter menos de 100 caracteres',
    slugHint: 'É a parte da URL que identifica exclusivamente este curso. Deve conter menos de 100 caracteres',
    keywords: 'Keywords',
    tags: 'Tags',
    tagsHint: 'Use ENTER para adicionar um novo item',
    bu: 'bu',
    cluster: 'Agrupamento',
    occupancy: 'Ocupação',
    active: 'Ativo',
    'active-plural': 'Ativo',
    'inactive-plural': 'Inativo',
    cohort: 'Ninhada',
    'select-state': 'Selecione o estado',
    'select-stage': 'Selecione a fase',
    'select-change-state-reason': 'Estabeleça o motivo da mudança',
    businessUnit: 'Unidade de negócios',
    'select-businessUnit': 'Selecione a unidade de negócios',
    'course-type': 'Tipo de Curso',
    'select-course-type': 'Selecione o tipo de curso',
    'full-name': 'Nome e sobrenome',
    'students-label': 'Alunos',
    'staff-label': 'Funcionários',
    'staff-students-label': 'Funcionários e alunos',
    'error-msg-generic': 'Ocorreu um erro. Tente novamente mais tarde.',
    loading: 'Carregando',
    'time-zone': 'fuso horário',
    apply: 'Aplicar',
    exist: 'existe',
    published: 'Publicado',
    yes: 'Sim',
    no: 'Não',
    filters: 'Filtros',
    track_stages: 'Estados do track',
    productStage: 'Estado do produto',
    enroll: 'Matricular',
    allowed_students: 'Tipo',
    showing: 'Mostrando <strong>{{start}}</strong> al <strong>{{end}}</strong> de <strong>{{total}}</strong> resultados',
    next: 'Próxima',
    previous: 'Anterior',
    product_type: 'Tipo de produto',
    courses: 'Cursos',
    coursesWithoutProduct: 'Esses cursos não estão associados a nenhum produto específico.',
    tracksWithoutProduct: 'Esses tracks não estão associados a nenhum produto específico.',
    role: 'Cargo',
  },
  errors: {
    'email-in-use': 'Esta conta já está vinculada a outro usuário do sistema',
    'wrong-identification-number': 'Você deve inserir um número válido',
  },
  language: {
    spanish: 'Espanhol',
    portuguese: 'Português',
    english: 'Inglês',
  },
};
